import { useState, useEffect } from 'react';
import { calculatePriceByService } from '../../utils/calculatePrice';

const AmountSelector = ({ value, onChange, service }) => {

    const minAmount = 20;
    const step = 20;
    const [inputValue, setInputValue] = useState(value.toString());
    const [price, setPrice] = useState(0)
    const handleBlur = () => {
    let newValue = parseInt(inputValue);

    if (!newValue) newValue = minAmount;

    newValue = Math.ceil(newValue / step) * step;
    newValue = Math.max(minAmount, newValue);

    setInputValue(newValue.toString());
    onChange(newValue);
    };

    const handleIncrement = () => {
        const newValue = value + step;
        onChange(newValue);
    };

    const handleDecrement = () => {
        const newValue = Math.max(minAmount, value - step);
        onChange(newValue);
    };

    const handleInputChange = (e) => {
    setInputValue(e.target.value);
    };

    useEffect(() => {
      setInputValue(value.toString());
      setPrice(calculatePriceByService(service, value));
    }, [value,service]);

  return (
    <>
       <div className="amount-selector">
      <label>Ilość w tonach (minimum 20)</label>
      
      <div className="amount-input-wrapper">
        <button 
          type="button"
          className="amount-btn minus"
          onClick={handleDecrement}
          disabled={value <= minAmount}
        >
          −
        </button>

        <input
        type="number"
        value={inputValue}
        onChange={handleInputChange}
        onBlur={handleBlur}
        min={minAmount}
        step={step}
        className="amount-input"
        />

        <button 
          type="button"
          className="amount-btn plus"
          onClick={handleIncrement}
        >
          +
        </button>
      </div>
    </div>
    <h4>Cena: <b>{price}zł</b> </h4>
    </>
 
  );
};

export default AmountSelector;